/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiMemberDtoCustomMemberFieldValueDto
 */
export interface WebApiMemberDtoCustomMemberFieldValueDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoCustomMemberFieldValueDto
     */
    fieldId?: number;
    /**
     * 
     * @type {any}
     * @memberof WebApiMemberDtoCustomMemberFieldValueDto
     */
    fieldValue?: any | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoCustomMemberFieldValueDto interface.
 */
export function instanceOfWebApiMemberDtoCustomMemberFieldValueDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoCustomMemberFieldValueDtoFromJSON(json: any): WebApiMemberDtoCustomMemberFieldValueDto {
    return WebApiMemberDtoCustomMemberFieldValueDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoCustomMemberFieldValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoCustomMemberFieldValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldId': !exists(json, 'fieldId') ? undefined : json['fieldId'],
        'fieldValue': !exists(json, 'fieldValue') ? undefined : json['fieldValue'],
    };
}

export function WebApiMemberDtoCustomMemberFieldValueDtoToJSON(value?: WebApiMemberDtoCustomMemberFieldValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldId': value.fieldId,
        'fieldValue': value.fieldValue,
    };
}

